import { getBrowserTimezone } from '../lib/DateTime.js';
import { InformationCircleIcon } from '@heroicons/react/24/outline/index.js';

const InfoMessageBlock = ({ children, className, showIcon, onClick }) => {
    return (
        <div
            className={`text-primary-700 bg-primary-100 p-4 rounded-lg ${className}`}
            onClick={onClick}
        >
            {showIcon && (
                <div className="flex">
                    <InformationCircleIcon className="w-5 h-5 mt-1 text-primary-700 mr-3 flex-shrink-0" />
                    <div className="leading-tight">{children}</div>
                </div>
            )}
            {!showIcon && children}
        </div>
    );
};

export default InfoMessageBlock;
